<template>
  <div>
    <Navigation />
    <section class="section__container top__container blog__details">
      <h1 class="title center__text">RÉPONSES CONSULTABLES</h1>
      <h2 class="center__text">
        Recevez les réponses SMS de vos destinataires lors de vos campagnes
      </h2>
      <p>
        Recevez les réponses SMS de vos clients directement dans votre boîte de réception de l'espace client. 
        Répondez, exportez et gérez les contacts, le tout sans frais supplémentaires. 
        La réception de SMS est disponible pour tous vos envois.
      </p>
      <h2>Optez pour l'acquisition d'un dispositif de communication interactif</h2>
      <p>
        En utilisant la fonctionnalité de SMS Réponse, vous pouvez demander une réponse de la part de vos clients, 
        favorisant ainsi l'interactivité avec eux. <br/>Que ce soit pour obtenir des informations, réaliser des statistiques, ou autres.
      </p>
      <h2>Mise en place d'une gestion dédiée pour les réponses STOP</h2>
      <p>
        En accord avec la législation en vigueur, la plateforme servicesms.sn 
        assure une gestion entièrement automatisée des réponses STOP. Ainsi, tout destinataire qui 
        répond STOP sera automatiquement ajouté à votre liste noire, ce qui empêchera toute réception ultérieure de SMS de votre part.
      </p>
      <h2>Offrez la possibilité de personnaliser l'expéditeur</h2>
      <p>Si vous choisissez de personnaliser l'expéditeur de vos SMS, vous ne recevrez pas les réponses. En revanche, 
        si vous n'utilisez pas de personnalisation d'expéditeur, vous recevrez les réponses. Dans ce cas, le SMS sera
         envoyé à partir d'un numéro court à 5 chiffres (par exemple, 22665). Vos destinataires au Sénégal pourront répondre à ce SMS. </p>
    </section>
    <Footer/>
  </div>
</template>

<script>
import Navigation from "./Navigation";
import Footer from "./Footer";
export default {
  components: {
    Navigation,
    Footer,
  },
};
</script>

</script>
<style lang="scss" scoped>
@import "../assets/base.scss";
</style>
